import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";
import { ref } from "vue";
import { IPricing } from "@/app/domain";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";

export class InstallationTotalCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent, [subtotalPrice, discountSum]): PriceResult {
        if (!subtotalPrice || !discountSum) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculateSubtotalPrice(
                discountSum, subtotalPrice,
                CostDealType,
            ),
            priceB2C: this.calculateSubtotalPrice(
                discountSum, subtotalPrice,
                B2CDealType,
            ),
            priceB2B: this.calculateSubtotalPrice(
                discountSum, subtotalPrice,
                B2BDealType,
            ),
        };
    }

    private calculateSubtotalPrice(
        discountSum: IPricing,
        subtotalPrice: IPricing,
        dealType: string,
    ) {
        if (discountSum.getSystemPrice(dealType).getValue() === 0) {
            return subtotalPrice.getSystemPrice(dealType).getValue();
        }

        const sum = subtotalPrice.getSystemPrice(dealType).getValue() - discountSum.getSystemPrice(dealType).getValue();

        return sum
    }
}
